// extracted by mini-css-extract-plugin
export default {"container":"TimeCell_container__HYpT3","placeHolderShimmer":"TimeCell_placeHolderShimmer__R73FW"};